import { render, staticRenderFns } from "./article.vue?vue&type=template&id=88b7e45e&"
import script from "./article.vue?vue&type=script&lang=js&"
export * from "./article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88b7e45e')) {
      api.createRecord('88b7e45e', component.options)
    } else {
      api.reload('88b7e45e', component.options)
    }
    module.hot.accept("./article.vue?vue&type=template&id=88b7e45e&", function () {
      api.rerender('88b7e45e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/contents-manage/article.vue"
export default component.exports